import { useTranslation } from 'react-i18next'
import cn from 'classnames/bind'

import styles from './PersonalLimitHeader.module.scss';


const cx = cn.bind(styles)

type Props = {
  currency: string
  limit: string | null | Array<unknown>
}

export const PersonalLimitHeader = ({
  currency,
  limit,
}: Props) => {
  const { t } = useTranslation('cafeteria')

  const limitNone = !limit
  const limitActive = !limitNone

  const limitText = (
    limit === null
      ? t('settings_limit_absent', 'Отсутствует')
      : `${limit}\u00A0${t('settings_limit_units', { currency })}`
  )

  return (
    <div className={styles.title}>
      {`${t('settings_limit_personal_label', 'Лимит расходов на личные покупки')}:\u00A0`}
      {!(limit instanceof Array)
        && <span className={cx({ limitActive, limitNone })}>
          {limitText}
        </span>}
    </div>
  )
}
